const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  routes: state => state.user.routes,
  menulist: state => state.user.menulist,
  perms: state => state.user.permslist
}
export default getters
